import { render } from "./CalendarConfigFormPopup.vue?vue&type=template&id=0855755f&scoped=true&ts=true"
import script from "./CalendarConfigFormPopup.vue?vue&type=script&lang=ts"
export * from "./CalendarConfigFormPopup.vue?vue&type=script&lang=ts"

import "./CalendarConfigFormPopup.vue?vue&type=style&index=0&id=0855755f&lang=scss&scoped=true"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0855755f"]])

export default __exports__